export default __webpack_public_path__ + "static/media/battery-60.288ba00c.svg";